import React, { createContext, useContext, useState } from 'react';
import { useYearsData, useYearTopTracks, useYearTopArtists } from '../hooks/useListeningHistory';

const HistoryContext = createContext();

/**
 * Provider component to manage listening history state globally
 */
export function HistoryProvider({ children }) {
  const [selectedYear, setSelectedYear] = useState(null);
  
  const { years, loading: yearsLoading } = useYearsData();
  const { tracks, tracksYear, loading: tracksLoading } = useYearTopTracks(selectedYear);
  const { artists, loading: artistsLoading } = useYearTopArtists(selectedYear);

  const value = {
    // Data
    years,
    selectedYear,
    topTracks: tracks,
    topTracksYear: tracksYear,
    topArtists: artists,
    
    // Loading states
    yearsLoading,
    tracksLoading,
    artistsLoading,
    isLoading: yearsLoading || tracksLoading || artistsLoading,
    
    // Actions
    selectYear: setSelectedYear,
  };

  return (
    <HistoryContext.Provider value={value}>
      {children}
    </HistoryContext.Provider>
  );
}

/**
 * Hook to use listening history context
 */
export function useHistory() {
  const context = useContext(HistoryContext);
  if (!context) {
    throw new Error('useHistory must be used within HistoryProvider');
  }
  return context;
}
